import Modal from "@/components/common/modal";
import { DialogFooter } from "@/components/ui/dialog";
import { cn } from "@/utils/theme";
import { Button /*Icon*/, Icon } from "@elaniintc/goes-design-system";

interface Props {
  userId: string | null;
  isOpen: boolean;
  onClose: () => void;
  isLoading?: boolean;
  onAccept: (val: { description: string }) => void;
}

const ReactivateModal = ({ isOpen, isLoading, onClose, onAccept }: Props) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Reactivar usuario"
      description="¿Estás seguro de que deseas reactivar este usuario? Puedes desactivarlo desde su perfil en cualquier momento."
      modalContentClassName="max-w-[520px] w-full gap-7"
    >
      <DialogFooter className="pt-1">
        <div className="w-full grid grid-cols-1 tablet:grid-cols-2 gap-3">
          <Button
            size="lg"
            type="button"
            className="w-full rounded-lg"
            variant="tertiary"
            onClick={onClose}
            //disabled={isLoading || isLoadingRoleData}
          >
            Cancelar
          </Button>
          <Button
            size="lg"
            className="w-full rounded-lg"
            type="button"
            disabled={isLoading}
            onClick={() => {
              onAccept({
                description: "Reactivación desde tabla",
              });
            }}
          >
            Reactivar
            {isLoading && (
              <Icon
                type="far"
                name={"spinner-third"}
                className={cn("text-current", "animate-spin")}
              />
            )}
          </Button>
        </div>
      </DialogFooter>
    </Modal>
  );
};

export default ReactivateModal;
